import type { LandingMessages } from '../types';

export const en: LandingMessages = {
  brand: 'My Budget',
  navAria: 'Primary',
  signIn: 'Sign in',
  headline: 'Stay within your budget without tracking every receipt',
  supporting:
    'Control spending, set clear goals, and see progress visually — so overruns show up while you can still fix them.',
  standaloneHeadline: 'Your budgets, ready here',
  standaloneSupporting: 'Sign in to open My Budget on this device.',
  startFree: 'Start free',
  seeHow: 'See how it works',
  pricingNote:
    'Free for the first customers. You can export your data anytime.',
  sessionExpired: 'Session expired.',
  problemLabel: 'The problem',
  problemTitle: 'Overspending feels invisible until the month ends',
  problemBody:
    'Without a clear plan and live view of your limits, small purchases stack up quietly. By the time you notice, the month is already gone.',
  howLabel: 'How it works',
  howTitle: 'Plan, track, and stay ahead',
  howLead:
    'No bank linking required. Define what matters, set limits, and watch spending against those goals in one calm view.',
  step1Title: 'Set clear goals',
  step1Body:
    'Decide what each budget is for — monthly living, a trip, or a shared household — so every limit has a purpose.',
  step2Title: 'Control spending by category',
  step2Body:
    'Give groceries, dining, and the rest monthly caps that match how you actually live.',
  step3Title: 'Spot overruns early',
  step3Body:
    'Visual progress shows when a category is getting tight or going over — while you can still course correct.',
  featuresLabel: 'What you get',
  featuresTitle: 'Clarity that keeps spending in check',
  featureControlTitle: 'Spending control',
  featureControlBody:
    'Category limits and live totals help you stay under the line without spreadsheet gymnastics.',
  featureOverrunTitle: 'Overrun visibility',
  featureOverrunBody:
    'See when you’re approaching or crossing a limit — clear visual signals, not month-end surprises.',
  featureVisualTitle: 'Visual information',
  featureVisualBody:
    'Progress bars and spending views make the month readable at a glance, even on a busy week.',
  featurePlanningTitle: 'Simple planning',
  featurePlanningBody:
    'Structure the month before it starts: budgets, categories, and amounts you can actually stick to.',
  featureGoalsTitle: 'Clear objectives',
  featureGoalsBody:
    'Name what each budget is for and keep personal or shared goals distinct when you need to.',
  abstractCategoryA: 'Groceries',
  abstractCategoryB: 'Dining out',
  abstractUsed: '{percent}% used',
  abstractNearLimit: 'Near limit',
  finalLabel: 'Start today',
  finalTitle: 'Clear limits. Calm spending.',
  finalLead:
    'Plan the month, control where money goes, and catch overruns early — with visuals that keep goals in sight.',
  apiKeysLabel: 'Automation',
  apiKeysTitle: 'Automate recording of your spending',
  apiKeysLead:
    'After you sign in, set it up in Settings — the guide shows how to connect iOS Shortcuts.',
  apiKeysCta: 'Read the setup guide',
  installLabel: 'On your phone',
  installTitle: 'Add to Home Screen',
  installLead:
    'Open My Budget like an app — faster access, full screen without the Safari bar, and notifications on supported iOS versions.',
  installStep1Title: 'Tap Share',
  installStep1Body:
    'In Safari, tap the Share button at the bottom of the screen.',
  installStep2Title: 'Add to Home Screen',
  installStep2Body:
    'Scroll the share sheet and choose Add to Home Screen.',
  installStep3Title: 'Confirm Add',
  installStep3Body:
    'Tap Add in the top right. My Budget appears on your Home Screen.',
  installAndroidNote:
    'On Android Chrome: open the browser menu → Install app or Add to Home screen.',
  footer: 'My Budget — personal finance without the spreadsheet stress.',
  languageAria: 'Language',
  langEn: 'EN',
  langEs: 'ES',
  documentTitle: 'My Budget',
};
